import { ITraining } from '../../../types/interfaces/training';
import { IUser } from '../../../types/interfaces/user';

export function getTrainingOwnerFormFields(
  training: ITraining | null | undefined,
  currentUser: IUser | undefined,
): {
  createForOthers: boolean;
  trainingOwner: IUser | null;
} {
  if (!training || !currentUser) {
    return { createForOthers: false, trainingOwner: null };
  }

  /** Someone else planned it for me; I am the performer. */
  const createdForMeByOther =
    training.permissions?.assignedToMeByAnotherPlanner === true;

  /** I planned for another performer. */
  const createdByMeForOther =
    training.permissions?.plannedByMeForAnotherPerformer === true;

  const createForOthers = createdForMeByOther || createdByMeForOther;

  const trainingOwner = createdForMeByOther
    ? currentUser
    : createdByMeForOther
      ? (training.owner ?? null)
      : null;

  return { createForOthers, trainingOwner };
}

export function getExerciseResultsUserIdForTrainingForm(
  trainingOwner: IUser | null | undefined,
  createForOthers: boolean | undefined,
  currentUserId?: string | undefined,
): string | undefined {
  if (!createForOthers || !trainingOwner?.id) {
    return undefined;
  }
  if (!currentUserId) {
    return undefined;
  }
  if (trainingOwner.id === currentUserId) {
    return undefined;
  }
  return trainingOwner.id;
}

export function getExerciseResultsUserIdForTrainingPerformer(
  trainingOwnerId: string | undefined,
  currentUserId: string | undefined,
): string | undefined {
  if (!trainingOwnerId || !currentUserId) {
    return undefined;
  }
  if (trainingOwnerId === currentUserId) {
    return undefined;
  }
  return trainingOwnerId;
}
